<template>
  <div>
    <v-app-bar class="px-2" app>
      <v-row class="text-decoration-none" align="center">
        <v-icon class="mr-2" @click="goToGamesList">
          mdi-arrow-left
        </v-icon>
        <div class="d-flex align-baseline">
          <h1
            :class="[
              'text-h5',
              'grey--text',
              $vuetify.theme.dark ? 'text--lighten-3' : 'text--darken-3'
            ]"
          >
            Pebbles
          </h1>
          <span class="ml-2 grey--text">
            &copy; {{ new Date().getFullYear() }}
          </span>
        </div>
      </v-row>
      <v-spacer />
      <v-row no-gutters>
        <div class="text-center">
          <div class="text-caption">Score</div>
          <div class="flex-grow-1 text-h5">{{ score }}</div>
        </div>
        <v-btn
          icon
          color="amber"
          class="ml-16"
          :elevation="4"
          :disabled="lastMove === null"
          @click.stop="undo"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-btn
          icon
          color="amber"
          class="mx-16"
          :elevation="4"
          :disabled="currentMove === null"
          @click.stop="redo"
        >
          <v-icon>mdi-arrow-right</v-icon>
        </v-btn>
        <div class="text-center">
          <div class="text-caption">Best score</div>
          <div class="flex-grow-1 text-h5">{{ bestScore }}</div>
        </div>
      </v-row>
      <v-spacer />
      <v-row align="center" class="flex-grow-0">
        <v-btn icon @click.stop="switchCssTheme">
          <v-icon>{{ $vuetify.theme.dark ? 'mdi-moon-waning-crescent' : 'mdi-white-balance-sunny' }}</v-icon>
        </v-btn>
        <v-btn icon @click.stop="showInfoPanel = true">
          <v-icon>mdi-help-circle-outline</v-icon>
        </v-btn>
      </v-row>
    </v-app-bar>

    <PopupHelp v-model="showInfoPanel" @close="showInfoPanel = false" />
  </div>
</template>

<script>
import { mapState } from "vuex";

import PopupHelp from "./PopupHelp.vue";

export default {
  name: "TopBar",
  components: { PopupHelp },
  data() {
    return {
      showInfoPanel: false
    };
  },
  created() {
    if (!localStorage.getItem("pebbles-has-shown-help")) {
      this.showInfoPanel = true;
      localStorage.setItem("pebbles-has-shown-help", true);
    }
  },
  computed: {
    ...mapState({
      room: (state) => state.room.room,
      lastMove: (state) => state.room.room.lastMove,
      currentMove: (state) => state.room.room.currentMove,
    }),
    bestScore() {
      return localStorage.getItem("pebbles-best-score") || 0;
    },
    score() {
      if (!this.room) return "";
      return this.room.score
    }
  },
  methods: {
    goToGamesList() {
      window.location.href = "https://minapecheux.com/games";
    },
    undo() {
      this.$store.dispatch("room/undo");
    },
    redo() {
      this.$store.dispatch("room/redo");
    },
    async switchCssTheme() {
      const usesDarkMode = this.$vuetify.theme.dark ? 0 : 1;
      localStorage.setItem("pebbles-dark-mode", usesDarkMode);
      this.$vuetify.theme.dark = usesDarkMode === 1;
      document.body.setAttribute("theme", this.$vuetify.theme.dark ? "dark" : "light");
    },
  },
};
</script>
